import React from 'react';

const Banner = () => {
  return (
    <div className='banner'>
      <a href='/'>fullhouse</a>
    </div>
  );
};

export default Banner;
